import { FieldOption } from '@components/form/v2';

import { useFormBuilderContext } from '../context';
import { FieldContainingOptions } from '../state';
import { filterOutExcludedOptions } from '../utils';

export const useFieldOptions = (field: FieldContainingOptions): FieldOption[] => {
  const { predefinedOptionsLists, marketplaceIntegrationLists = [] } = useFormBuilderContext();

  if (!field.optionsFromListId) {
    return field.options;
  }

  const excludedOptions = field.excludedOptions ?? [];

  const predefinedList = predefinedOptionsLists.find(
    (list) => list.value === field.optionsFromListId
  );

  if (predefinedList && !predefinedList.isHidden) {
    return filterOutExcludedOptions(predefinedList.options, excludedOptions);
  }

  for (const integration of marketplaceIntegrationLists) {
    const marketplaceList = integration.lists.find(
      (list) => list.shortId === field.optionsFromListId
    );
    if (marketplaceList) {
      return filterOutExcludedOptions(marketplaceList.options, excludedOptions);
    }
  }

  return field.options;
};
